import {
  EventTriggeringConditionType,
  FetchProjectTriggersQueryResult,
} from '../../generated/graphql';

export const getTitleAndMessage = (
  eventType: EventTriggeringConditionType,
  artifactCollectionName: string
) => {
  let title = 'Automated Notification';
  let message = 'Event fired';
  if (eventType === EventTriggeringConditionType.LinkModel) {
    title = `New model version linked to the registered model: ${artifactCollectionName}`;
    message = `Insert Artifact Info here`;
  }
  return {title, message};
};

export function getNotificationTriggers(
  artifactCollectionID: string,
  triggersQueryResult: FetchProjectTriggersQueryResult
) {
  // TODO: Add triggers edge from ArtifactCollection to make this cleaner.
  const projectTriggers = triggersQueryResult.data?.project?.triggers ?? [];
  const artifactCollectionScopes = ['ArtifactSequence', 'ArtifactPortfolio'];
  return projectTriggers.filter(t => {
    return (
      t.triggeredAction.__typename === 'NotificationTriggeredAction' &&
      artifactCollectionScopes.includes(t.scope.__typename) &&
      t.scope.id === artifactCollectionID
    );
  });
}

export function getDescription(
  artifactCollectionName: string,
  eventType: EventTriggeringConditionType
) {
  if (eventType === EventTriggeringConditionType.LinkModel) {
    return `New model version linked to "${artifactCollectionName}".`;
  }
  return '';
}
